
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_3gfu1_3yy3l_5"
};
  